import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink border-t border-line mt-24">
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 grid md:grid-cols-4 gap-12">
      <div className="md:col-span-1">
        <div className="flex items-center gap-3">
          <span className="font-bodoni text-4xl text-rose tracking-tighter">DN</span>
          <div className="border-l border-white/15 pl-3">
            <h3 className="font-serif-display text-2xl text-white tracking-[0.12em]">DONNA NARA</h3>
            <p className="label-caps text-rose text-[9px] mt-0.5 tracking-[0.3em]">Moda Feminina</p>
          </div>
        </div>
        <p className="font-bodoni italic text-white/60 text-lg mt-4">Thainara Franciele</p>
        <p className="text-white/50 text-sm mt-4 leading-relaxed font-light">
          Moda que inspira. Elegância que acompanha você em todas as estações.
        </p>
        <div className="flex flex-col gap-2 mt-6 text-sm text-white/60">
          <a href="https://instagram.com/donnanara.oficial" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-rose transition-colors duration-300"><Instagram size={15} /> @donnanara.oficial</a>
          <span className="flex items-center gap-2"><Phone size={15} /> (11) 9 1399-XXXX</span>
          <span className="flex items-center gap-2"><MapPin size={15} /> São Paulo · SP</span>
        </div>
      </div>

      <div>
        <p className="label-caps text-white/40 mb-5">Coleções</p>
        <ul className="space-y-3 text-sm text-white/60 font-light">
          {["Primavera", "Verão", "Outono", "Inverno"].map((c) => (
            <li key={c}><Link to={`/loja?col=${c}`} className="hover:text-rose transition-colors duration-300">{c}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <p className="label-caps text-white/40 mb-5">Ajuda</p>
        <ul className="space-y-3 text-sm text-white/60 font-light">
          <li>Como comprar</li>
          <li>Trocas e devoluções</li>
          <li>Entrega para todo o Brasil</li>
          <li>Atendimento: Seg–Sex, 8h às 18h</li>
        </ul>
      </div>

      <div>
        <p className="label-caps text-white/40 mb-5">Pagamento</p>
        <div className="flex flex-wrap gap-2">
          {["Pix", "Crédito", "Débito", "Boleto"].map((p) => (
            <span key={p} className="border border-line px-3 py-1.5 text-xs text-white/70">{p}</span>
          ))}
        </div>
        <p className="text-white/40 text-xs mt-4">Parcele em até 12x no cartão, conforme condições da loja.</p>
      </div>
    </div>
    <div className="border-t border-line py-6 text-center">
      <p className="text-white/30 text-xs">© {new Date().getFullYear()} Donna Nara Moda Feminina · Todos os direitos reservados.</p>
    </div>
  </footer>
);
